package com.eladfinish.bible.contest.screens.settings

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.Stable
import com.eladfinish.bible.contest.arch.ActionKt
import com.eladfinish.bible.contest.arch.EffectKt
import com.eladfinish.bible.contest.arch.StateKt

@Immutable
data class SettingsState(
    val isLoading: Boolean,
    val dialogState: DialogState,
) : StateKt {

    @Stable
    sealed class DialogState {
        data class RandomApproachExplanation(val content: String) : DialogState()
        data class FontPreview(val selectedFont: String) : DialogState()
        data object None : DialogState()
    }
}

sealed class SettingsAction : ActionKt {
    data object RandomApproachChanged : SettingsAction()
    data class FontChanged(val selectedFont: String) : SettingsAction()
    data class LanguageSelected(val selectedLanguage: String) : SettingsAction()
    internal data class ApplyFontChange(val selectedFont: String) : SettingsAction()
    data object HideDialog : SettingsAction()
}

sealed interface SettingsEffect : EffectKt {
    data object ApplyFontChange : SettingsEffect
}
